<!--
    AssetImageManager

    DESCRIPTION
    a component for viewing asset media

    Asset media comes from the asset store
-->

<template>

    <div v-if="asset_images.length == 0">
        <EmptyList :heading="`No ${file_noun}`" :message="`This vehicle doesn't have any ${file_noun} yet.`" />
    </div>
    
    <div v-if="asset_images.length > 0" class="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <AssetImageManagerItem v-for="media in asset_images" :key="media.id" :media="media" :asset_id="asset_id" :media_types="media_types" v-on:refresh="getAssetMedia()" />
    </div>

</template>

<script>
import { useAssetStore } from '@sto/asset.store'
import { onBeforeMount, watch, computed, reactive } from 'vue';

import AssetImageManagerItem from '@par/asset/AssetImageManagerItem.vue'

export default {
    components: {
        AssetImageManagerItem
    },
    props: ['asset_id','asset_type','media_types'],
    setup(props) {
        const ASSET_STORE = useAssetStore()

        const state = reactive({
            asset_media: null
        })

        const getAssetMedia = async () => {

            if (props.asset_id) {
                await ASSET_STORE.getMedia(props.asset_id, props.media_types)
                state.asset_media = ASSET_STORE.getterAssetMedia(props.asset_id)
            }
        }

        const asset_images = computed(() => {
            return state.asset_media && state.asset_media.image ? state.asset_media.image : []
        })

        const file_noun = computed(() => {
            if (!Array.isArray(props.media_types) || props.media_types.length > 1) return 'media'

            switch(props.media_types[0]) {
                case 'image':
                    return 'photos'
                default:
                    return 'media'
            }
        })

        watch(
            () => props.asset_id,
            (new_value, old_value) => {
                getAssetMedia()
            }
        )

        onBeforeMount(() => {
            getAssetMedia()
        })

        return {
            state,
            asset_images,
            file_noun,
            getAssetMedia
        }
    },
}
</script>